import fetch from './fetch'

export default {
  getLocations (payload) {
    let request = fetch({
      url: `/location`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getLocation (payload) {
    const id = payload.id
    let request = fetch({
      url: `/location/` + id,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  createLocation (payload) {
    let request = fetch({
      url: `/location`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  updateLocation (payload) {
    const { id, data } = payload
    let request = fetch({
      url: `/location/` + id,
      method: 'patch',
      data: data
    })
    return request.call()
  },
  deleteLocation (payload) {
    const id = payload.id
    let request = fetch({
      url: `/location/` + id,
      method: 'delete'
    })
    return request.call()
  }
}



// WEBPACK FOOTER //
// ./src/api/location.js